type SpinnerProps = {
  size?: "standard" | "small" | "large";
  variant?: "primary" | "secondary";
};

const sizes = {
  standard: {
    size: 34,
    strokeWidth: 2,
  },
  small: {
    size: 18,
    strokeWidth: 4,
  },
  large: {
    size: 72,
    strokeWidth: 2,
  },
};

const colors = {
  primary: {
    outerStroke: "#a61154",
    innerStroke: "#e6e6e6",
  },
  secondary: {
    outerStroke: "#ffffff",
    innerStroke: "#b84176",
  },
};

export default function Spinner({
  size = "standard",
  variant = "primary",
}: SpinnerProps) {
  return (
    <svg
      width={sizes[size].size}
      height={sizes[size].size}
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      stroke={colors[variant].outerStroke}
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth={sizes[size].strokeWidth}>
          <circle stroke={colors[variant].innerStroke} cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
}
